"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsLink = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable jsx-a11y/anchor-is-valid -- X */

const TermsLink = ({
  children,
  onClick
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
  component: "button",
  variant: "body1",
  sx: {
    verticalAlign: 'top',
    fontSize: theme => theme.typography.pxToRem(12),
    lineHeight: 1.75
  },
  onClick: onClick,
  children: children
});
exports.TermsLink = TermsLink;